import React, { useEffect, useState, useCallback } from "react";
import Box from "@mui/material/Box";
// DataGridFunction Component
import DataGridFunction from "../../components/datagridComponent/datagrid";
// postPlus button component
import PostPlusButton from "../../components/postPlusButton/PostPlusButton";
import ActivityTypeAction from "../../stores/influencerActivityType/ActivityTypeAction";
import LoadingIndicator from "../../components/loading-indicator/LoadingIndicator";
import { selectRequesting } from "../../selectors/requesting/RequestingSelector";
import { connect } from "react-redux";
import AutoCompleteComponent from "../../components/autoCompleteComponent/Autocomplete";
import MuiButton from "../../components/muiButton/MuiButton";
import Grid from "@mui/material/Grid";
import { IconButton } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare } from "@fortawesome/free-regular-svg-icons";
import ActivityTypePost from "./ActivityTypePost";
import InfluencersCampaignsAction from "../../stores/influencersCampaigns/InfluencersCampaignsAction";

// mapstatetoprops function

const mapStateToProps = (state) => ({
  isRequesting: selectRequesting(state, [
    ActivityTypeAction.REQUEST_ACTIVITY_TYPE,
    ActivityTypeAction.REQUEST_ACTIVITY_TYPE_FILTER,
    InfluencersCampaignsAction.REQUEST_INFLUENCERS_CAMPAIGNS_FILTER,
  ]),
  activityType: state.activityType.activityType || [],
  activityTypeFilter: state.activityTypeFilter.activityTypeFilter || [],
  influencersCampaignFilter:
    state.influencersCampaignFilter.influencersCampaignFilter || [],
  pagination: state.activityType.activityType || [],
});

function ActivityTypeList(props) {
  const { isRequesting } = props;

  const [searchActivityType, setsearchActivityType] = useState(null);
  const [open, setOpen] = useState(false);
  const [edit, setEdit] = useState(false);
  const [editRowsModel, setEditRowsModel] = useState({});
  const [page_limit] = useState(15);
  const [filterLoader, setFilterLoader] = useState(false);
  const [clearLoader, setClearLoader] = useState(false);
  const [FilterClicked, setFilterClicked] = useState(false);

  // post plus button close model
  const openCloseModal = useCallback((open) => {
    setOpen(open);
  }, []);

  const editMode = useCallback((edit) => {
    setEdit(false);
  }, []);

  useEffect(() => {
    if (!isRequesting) {
      setFilterLoader(false);
      setClearLoader(false);
    }
  }, [isRequesting]);

  function fetchActivityType(params) {
    props.dispatch(ActivityTypeAction.requestActivityType(params));
  }

  function fetchActivityTypeFilter(params) {
    props.dispatch(ActivityTypeAction.requestActivityTypeFilter(params));
  }

  function fetchInfluencerscampaignsFilter(params) {
    props.dispatch(InfluencersCampaignsAction.requestInfluencersFilter(params));
  }

  useEffect(() => {
    const param = {
      page_limit: "none",
    };
    const params = {
      order_by: '[["created_on", "desc"]]',
      page_limit: page_limit,
    };
    fetchActivityType(params);
    fetchActivityTypeFilter(param);
    fetchInfluencerscampaignsFilter(param);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const filterArray = [];
  if (searchActivityType !== null) {
    filterArray.push(
      `["activity_type_name.keyword","must","","term","${searchActivityType.activityTypeName}"]`
    );
  }

  const handleFilter = () => {
    if (searchActivityType !== null) {
      const params = {
        filters: `[${filterArray}]`,
        page_limit: page_limit,
        order_by: '[["created_on", "desc"]]',
      };
      fetchActivityType(params);
      setFilterLoader(true);
      setFilterClicked(true);
    } else {
      alert("Please add filters");
    }
  };

  const ClearState = () => {
    if (searchActivityType !== null) {
      setsearchActivityType(null);
    }
    setClearLoader(true);
    setFilterClicked(false);

    const params = {
      order_by: '[["created_on", "desc"]]',
      page_limit: page_limit,
    };

    fetchActivityType(params);
  };

  const handleChange = (event, value) => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });

    let params = {};

    if (searchActivityType !== null && FilterClicked) {
      params = {
        filters: `[${filterArray}]`,
        page_number: `${value}` - 1,
        page_limit: `${page_limit}`,
        order_by: '[["created_on", "desc"]]',
      };
    } else {
      params = {
        page_number: `${value}` - 1,
        page_limit: `${page_limit}`,
        order_by: '[["created_on", "desc"]]',
      };
    }

    fetchActivityType(params);
  };

  const ActivityTypeHandleChange = (event, activityType) => {
    if (activityType != null) {
      setsearchActivityType(activityType);
    } else {
      setsearchActivityType(null);
    }
  };

  const columns = [
    {
      field: "sl_no",
      headerName: "SL NO",
      width: 150,
      flex: 2,
      resizable: false,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "id",
      headerName: "ID",
      hide: true,
    },
    {
      field: "activity_type",
      headerName: "Activity Type",
      width: 250,
      flex: 4,
    },
    {
      field: "campaignName",
      headerName: "Campaign",
      width: 250,
      flex: 4,
    },
    {
      field: "created_by",
      headerName: "Created By",
      width: 250,
      flex: 4,
    },
    {
      field: "actions",
      type: "actions",
      headerName: "Edit",
      width: 160,
      flex: 2,
      cellClassName: "actions",
      renderCell: (params) => (
        <IconButton
          title="Edit"
          onClick={(event) => {
            event.ignore = true;
            setEdit(true);
            setOpen(true);
            setEditRowsModel(params.row);
          }}
          sx={{ border: "0" }}
        >
          <FontAwesomeIcon
            icon={faPenToSquare}
            style={{ height: "20px", width: "20px", color: "#2a5e6c" }}
            title="Edit"
          ></FontAwesomeIcon>
        </IconButton>
      ),
    },
  ];

  const rows = [];

  if (props.activityType) {
    props.activityType.hits &&
      props.activityType.hits.hits &&
      props.activityType.hits.hits.length > 0 &&
      props.activityType.hits.hits.map((item, index) => {
        return rows.push({
          sl_no: item._id
            ? props.pagination.current_page_no * page_limit + ++index
            : "",
          id: item._id,
          activity_type: item._source.activity_type_name,
          created_by: item._source.created_by.user_name,
          campaign: item._source.campaign,
          campaignName: item._source.campaign.campaign_name,
        });
      });
  }

  let activityTypeList = [];
  props.activityTypeFilter &&
    props.activityTypeFilter.hits &&
    props.activityTypeFilter.hits.hits.forEach((item) => {
      activityTypeList.push({
        activityTypeID: item._id,
        activityTypeName: item._source.activity_type_name,
      });
    });

  let campaignNameList = [];

  if (props.influencersCampaignFilter) {
    props.influencersCampaignFilter.hits &&
      props.influencersCampaignFilter.hits.hits &&
      props.influencersCampaignFilter.hits.hits.map((item) => {
        return campaignNameList.push({
          campaign_id: item._id,
          campaign_name: item._source.campaign_name,
        });
      });
  }

  return (
    <React.Fragment>
      <Box>
        <ActivityTypePost
          open={open}
          onSubmit={() => {}}
          onClose={() => {
            setOpen(false);
          }}
          edit={edit}
          campaignArray={campaignNameList}
          editData={editRowsModel}
        />

        <Grid container>
          <Grid
            container
            lg={12}
            md={12}
            sm={12}
            justifyContent="center"
            spacing={1}
          >
            <Grid item lg={2} md={3} sm={3.5} mt={1}>
              <AutoCompleteComponent
                value={searchActivityType}
                list={activityTypeList}
                isOptionEqualToValue={(option, value) =>
                  option.activityTypeId === value.activityTypeID
                }
                getOptionLabel={(option) =>
                  option.activityTypeName ? option.activityTypeName : ""
                }
                textFieldProps={{
                  placeholder: "Activity Type",
                }}
                handleChange={ActivityTypeHandleChange}
                size="small"
                width="100%"
              />
            </Grid>
            <Grid item lg={6} md={6} sm={5}>
              <Grid
                item
                lg={12}
                md={12}
                sm={12}
                container
                spacing={2}
                justifyContent="flex-end"
                mt={0}
              >
                <Grid
                  lg={8}
                  sm={8}
                  md={8}
                  display={"flex"}
                  justifyContent={"end"}
                  mt={1}
                  mr={2}
                  sx={{ gap: 2 }}
                >
                  <Grid lg={3} md={3} sm={3}>
                    <MuiButton
                      width="100%"
                      name={"Filter"}
                      onClick={handleFilter}
                      loading={filterLoader && isRequesting}
                    />
                  </Grid>
                  <Grid lg={3} md={3} sm={3}>
                    <MuiButton
                      name={"Clear"}
                      width="100%"
                      onClick={ClearState}
                      loading={clearLoader && isRequesting}
                    />
                  </Grid>
                </Grid>
                <Grid>
                  {/* post button component*/}
                  <PostPlusButton
                    open={open}
                    openCloseModal={openCloseModal}
                    editMode={editMode}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        {navigator.onLine ? (
          <Box>
            <Grid
              display="flex"
              justifyContent="center"
              container
              item
              lg={12}
              md={12}
              sm={12}
            >
              {" "}
              <Grid item lg={8} md={12} sm={12} xs={12}>
                <LoadingIndicator isActive={isRequesting}>
                  {props.activityType &&
                  props.activityType.hits &&
                  props.activityType.hits.hits ? (
                    <DataGridFunction
                      columns={columns}
                      rows={rows}
                      rowHeight={60}
                      pagelength={props.pagination.total_page_no}
                      page={props.pagination.current_page_no}
                      handleChange={handleChange}
                    />
                  ) : null}
                </LoadingIndicator>
              </Grid>
            </Grid>
          </Box>
        ) : (
          alert("No Internet Connection") || (
            <h3 style={{ textAlign: "center" }}>No Internet Connection</h3>
          )
        )}
      </Box>
    </React.Fragment>
  );
}

export default connect(mapStateToProps)(ActivityTypeList);
